import { render, staticRenderFns } from "./TriggerActionLookup.vue?vue&type=template&id=28badab6&lang=pug"
import script from "./TriggerActionLookup.vue?vue&type=script&lang=js"
export * from "./TriggerActionLookup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports